import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import { AdditionalInformationSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/AdditionalInformation/form/schema'
import { OwnerFieldSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/BasicInformation/form/OwnerField/schema'
import { BudgetSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Budget/form/schema'
import {
  CategorySchema,
  superRefineCategorySchema,
} from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Category/form/schema'
import { CostCenterSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/CostCenters/form/schema'
import { DateTimeSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/DateTimeRange/form/schema'
import { GroupSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Group/form/schema'
import { PerDiemRatesSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/PerDiemRates/form/schema'
import { ProjectsSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Projects/form/schema'
import { TripInformationSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Trip/form/schema'
import { FilesSchema } from 'modules/expenses/components/expenses/Detail/_newForm/Files/form/schema'
import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'
import { ProjectWorker } from 'modules/expenses/hooks/useProjects'
import { BudgetOption } from 'modules/finance/hooks/useBudgets'

interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  budgetOptions: BudgetOption[]
  projectWorkers: ProjectWorker[]
  hasProjectsFeature: boolean
  hasCostCentersFeature: boolean
}
export const PerDiemSchema = ({
  customizationFields,
  budgetOptions,
  projectWorkers,
  hasProjectsFeature,
  resourceType,
  hasCostCentersFeature,
}: FormContext) => {
  return z
    .object({
      ...OwnerFieldSchema().shape,
      ...CategorySchema().shape,
      ...AdditionalInformationSchema({
        customizationFields,
        resourceType: 'perdiem',
      }).shape,
      ...BudgetSchema({
        customizationFields,
        budgetOptions,
        resourceType: 'perdiem',
      }).shape,
      ...TripInformationSchema({
        customizationFields,
        resourceType: 'perdiem',
      }).shape,
      ...DateTimeSchema({
        customizationFields,
        resourceType: 'perdiem',
      }).shape,
      ...PerDiemRatesSchema({
        customizationFields,
        resourceType: 'perdiem',
      }).shape,
      ...ProjectsSchema({
        customizationFields,
        projectWorkers,
        hasProjectsFeature,
        resourceType: 'perdiem',
      }).shape,
      ...CostCenterSchema({
        customizationFields,
        hasCostCentersFeature,
        resourceType: 'perdiem',
      }).shape,
      ...FilesSchema({
        customizationFields,
        resourceType: 'perdiem',
      }).shape,
      ...GroupSchema().shape,
    })
    .superRefine((data, ctx) => {
      superRefineCategorySchema({
        data,
        ctx,
        customizationFields,
        resourceType,
      })
    })
}

export type PerDiemSchema = z.infer<ReturnType<typeof PerDiemSchema>>
